<template>
    <BaseForm>
        <template #fields>
            <MultiLink
                :label="$t('extra-documents')"
                :links="values.extraDocuments"
                :error-messages="errors.extraDocuments"
                @input="setFieldValue('extraDocuments', $event)"
                @delete="setFieldValue('extraDocuments', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventDocumentsSchema } from '../schemas';

const { event, createEventMultiLink } = useEventInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventMultiLink);

const extraDocumentsId = computed(() => event.value?.extraDocuments?.id);
const extraDocumentsLinks = computed(() => event.value?.extraDocuments?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventDocumentsSchema,
    computed(() => ({
        extraDocuments: getFormFieldLinks(extraDocumentsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: extraDocumentsId.value, fieldName: 'extraDocuments', links: values.value.extraDocuments },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
